import type { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { editorService } from '../../services';

export function useProjectMediaDelete(projectId: ID): UseMutationResult<void, AxiosError, ID> {
    return useMutation((mediaId: ID) => editorService.deleteMedia(projectId, mediaId));
}
